module.exports = __webpack_public_path__ + "static/template-team-member-2-a6fcd9bcfe08067f40e32566e9a4d336.jpg";